import React, { useState } from "react";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

import {
    FaPray,
    FaMicrophoneAlt,
    FaNewspaper,
    FaUsers,
} from "react-icons/fa";

const Assembly = () => {

    const [open, setOpen] =
        useState(false);

    const programmes = [

        "Prayer",
        "Prayer Song",
        "Pledge",
        "Thoughts",
        "G.K. Questions",
        "Short Speech (Hindi)",
        "News Reading",
        "Physical Exercise",
        "Birthday Wishing",
        "Short Speech by a Teacher",
        "National Anthem",

    ];

    const weeklyIncharge = [

        {
            week: "1st week",
            teacher: "Mr. A. Britto",
        },

        {
            week: "2nd week",
            teacher: "Miss. Anuradha Singh",
        },

        {
            week: "3rd week",
            teacher: "Mrs. Babita Singh",
        },

        {
            week: "4th week",
            teacher: "Mr. Ashutosh Kumar Upadhyay",
        },

    ];

    return (

        <>
            <Header
                toggleSidebar={() =>
                    setOpen(true)
                }
            />

            <Sidebar
                isOpen={open}
                close={() =>
                    setOpen(false)
                }
            />

            {/* PAGE */}
            <section className="w-full bg-[#f7f9fc] overflow-x-hidden">

                {/* HERO SECTION */}
                <div className="bg-gradient-to-r from-[#072F5F] to-[#0B4F9C] py-16 md:py-20">

                    <div className="max-w-7xl mx-auto px-5 md:px-10 text-center">

                        <span className="text-[#D4A017] uppercase tracking-[4px] text-xs md:text-sm font-semibold">

                            School Activities

                        </span>

                        <h1 className="text-4xl md:text-6xl font-extrabold text-white mt-4">

                            School Assembly

                        </h1>

                        <p className="text-gray-200 text-base md:text-lg mt-5 max-w-3xl mx-auto leading-8">

                            Morning assembly helps students develop discipline,
                            confidence, leadership and positive values while
                            beginning the day with motivation and inspiration.

                        </p>

                    </div>

                </div>

                {/* MAIN CONTENT */}
                <div className="max-w-7xl mx-auto px-5 md:px-10 py-16">

                    {/* TOP CARDS */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                        {/* PRAYER */}
                        <div className="bg-white rounded-2xl border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 px-6 py-7 flex items-center gap-5">

                            <div className="w-14 h-14 rounded-xl bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-xl shrink-0">

                                <FaPray />

                            </div>

                            <div>

                                <h3 className="text-2xl font-bold text-[#072F5F] mb-2">

                                    Daily Prayer

                                </h3>

                                <div className="w-10 h-[2px] bg-[#D4A017] mb-3"></div>

                                <p className="text-gray-600 leading-7 text-[15px]">

                                    The assembly begins with prayer and prayer
                                    song to create a peaceful and positive
                                    atmosphere.

                                </p>

                            </div>

                        </div>

                        {/* SPEECH */}
                        <div className="bg-white rounded-2xl border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 px-6 py-7 flex items-center gap-5">

                            <div className="w-14 h-14 rounded-xl bg-[#D4A017]/10 text-[#D4A017] flex items-center justify-center text-xl shrink-0">

                                <FaMicrophoneAlt />

                            </div>

                            <div>

                                <h3 className="text-2xl font-bold text-[#072F5F] mb-2">

                                    Student Speech

                                </h3>

                                <div className="w-10 h-[2px] bg-[#D4A017] mb-3"></div>

                                <p className="text-gray-600 leading-7 text-[15px]">

                                    Students participate through speeches,
                                    thoughts and G.K. questions to improve
                                    communication skills.

                                </p>

                            </div>

                        </div>

                        {/* NEWS */}
                        <div className="bg-white rounded-2xl border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 px-6 py-7 flex items-center gap-5">

                            <div className="w-14 h-14 rounded-xl bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-xl shrink-0">

                                <FaNewspaper />

                            </div>

                            <div>

                                <h3 className="text-2xl font-bold text-[#072F5F] mb-2">

                                    News Reading

                                </h3>

                                <div className="w-10 h-[2px] bg-[#D4A017] mb-3"></div>

                                <p className="text-gray-600 leading-7 text-[15px]">

                                    Students stay updated with current affairs
                                    through daily news reading activities.

                                </p>

                            </div>

                        </div>

                    </div>

                    {/* PROGRAMMES + INCHARGE */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mt-16">

                        {/* PROGRAMMES */}
                        <div className="bg-white rounded-3xl shadow-xl p-6 md:p-10 border border-gray-100">

                            <div className="flex items-center gap-4 mb-8">

                                <div className="w-14 h-14 rounded-2xl bg-[#0B4F9C]/10 text-[#0B4F9C] flex items-center justify-center text-2xl">

                                    <FaUsers />

                                </div>

                                <div>

                                    <h2 className="text-3xl md:text-4xl font-extrabold text-[#072F5F]">

                                        Assembly Programmes

                                    </h2>

                                    <div className="w-16 h-[3px] bg-[#D4A017] mt-3 rounded-full"></div>

                                </div>

                            </div>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

                                {
                                    programmes.map(
                                        (
                                            item,
                                            index
                                        ) => (

                                            <div
                                                key={index}
                                                className="
                                                    bg-[#f7f9fc]
                                                    border
                                                    border-gray-100
                                                    rounded-2xl
                                                    px-5
                                                    py-4
                                                    text-[#072F5F]
                                                    font-semibold
                                                    shadow-sm
                                                    hover:shadow-md
                                                    transition-all
                                                    duration-300
                                                "
                                            >

                                                {item}

                                            </div>
                                        )
                                    )
                                }

                            </div>

                        </div>

                        {/* WEEKLY INCHARGE */}
                        <div className="bg-white rounded-3xl shadow-xl p-6 md:p-10 border border-gray-100">

                            <h2 className="text-3xl md:text-4xl font-extrabold text-[#072F5F] mb-3">

                                Weekly Incharge

                            </h2>

                            <div className="w-16 h-[3px] bg-[#D4A017] rounded-full mb-8"></div>

                            <div className="space-y-5">

                                {
                                    weeklyIncharge.map(
                                        (
                                            item,
                                            index
                                        ) => (

                                            <div
                                                key={index}
                                                className="
                                                    flex
                                                    flex-col
                                                    sm:flex-row
                                                    sm:items-center
                                                    sm:justify-between
                                                    gap-3
                                                    bg-[#f7f9fc]
                                                    border
                                                    border-gray-100
                                                    rounded-2xl
                                                    px-5
                                                    py-5
                                                    shadow-sm
                                                    hover:shadow-md
                                                    transition-all
                                                    duration-300
                                                "
                                            >

                                                <span className="text-[#0B4F9C] font-bold text-lg">

                                                    {item.week}

                                                </span>

                                                <span className="text-gray-700 font-medium text-[16px]">

                                                    {item.teacher}

                                                </span>

                                            </div>
                                        )
                                    )
                                }

                            </div>

                        </div>

                    </div>

                </div>

            </section>

            <Footer />
        </>
    );
};

export default Assembly;